export default "__VITE_ASSET__BkCuiCf0__"